import ReviewAssetsPage from "domains/liquidity/pages/ReviewAssetsPage/ReviewAssetsPage";

export default ReviewAssetsPage;
